import SettingsHandler from "components/Account";
import SettingsSettingsHandler from "components/Account/Options";
import FeatureFlagList from "components/Account/FeatureFlagList";
import Profile from "Accounts/Profile/View";

import { hot } from "App/Config/hot";

const Account = {
  SettingsSettingsHandler,
  FeatureFlagList,
  SettingsHandler,
  Profile
};

export default hot(Account);
